export default "__VITE_ASSET__MxtY4anu__"